define('responsive-pitch-fx/lib/math/gcd',['require','exports','module'],function(require,exports,module){
	var gcd;
	return gcd=function(a, b) {
        if (b === 0) {
            return a;
        }

        return gcd(b, a % b);
    };

});
